import DrawAngleAnim from "../DrawAngleAnim";
import DrawCircleAnim from "../DrawCirleAnimation";
import DrawLineAnim from "../DrawLineAnimation";
import DrawPointAnim from "../DrawPointAnimation";
import RotateCircleAnim from "../RotateCircleAnim";

import SwapSprite from "../../SwapSprite";
import MovePointAnimation from "../MovePointAnim";
import { Coord } from "../../../types/Interface";
import Circle from "../../../entities/Circle";
import Line from "../../../entities/Line/Line";
import BaseSliderManager from "../../../managers/BaseSliderManager/BaseSliderManager";
import Point from "../../../entities/Point";
import RedPoint from "../../../entities/RedPoint";
import Angle from "../../../entities/Angle/Angle";
import CustomDelay from "../../CustomDelay";


export function drawPointsAnim(pointsArr: (Point | RedPoint)[]): Promise<void> {
  return new Promise(resolve => {
    pointsArr.forEach((point: any) => new DrawPointAnim(point, resolve, resolve))
  })
}

export function drawAngleAnim(angle: Angle, value: string): Promise<void> {
  return new Promise(resolve => {
    new DrawAngleAnim(angle, () => {
      angle.AngleValue.setValue(value);
      angle.AngleValue.visible = true;
      resolve();
    }, resolve);
  });
}

export function drawLineAnim(line: Line, from: Coord, to: Coord): Promise<void> {
  return new Promise(resolve => {
    line.visible = true;
    new DrawLineAnim(line, from, to, undefined, resolve, resolve);
  });
}

export function drawCircleAnim(circle: Circle, radian: number, radianIndex: number, isTransparent: boolean, coord: Coord): Promise<void> {
  return new Promise(resolve => {
    new DrawCircleAnim(circle, radian, radianIndex, isTransparent, coord, resolve, resolve);
  });
}

export function movePointAnim(sAngle: number, tAngle: number, callback: (a: number) => void, onComp = () => { }): Promise<void> {
  return new Promise(resolve => {
    new MovePointAnimation(sAngle, tAngle, callback, () => {
      onComp();
      resolve();
    }, resolve)
  })
}

export function moveAllPointAnim(sAngleArr: number[], tAngleArr: number[], callback: (angle: number, index: number) => void): Promise<void> {
  return new Promise(resolve => {
    tAngleArr.forEach(async (tAngle, tAIndex) => {
      if (tAIndex < tAngleArr.length - 1) {
        return movePointAnim(sAngleArr[tAIndex], tAngle, (angle) => callback(angle, tAIndex));
      }
      await movePointAnim(sAngleArr[tAIndex], tAngle, (angle) => callback(angle, tAIndex), () => resolve());
    })
  })
}

export function showSlidersAnim(SliderManager: BaseSliderManager): Promise<void> {
  return new Promise(() => {
    const sliders = SliderManager.getSliders();
    sliders.forEach(slider => {
      const onUpdate = (v: number) => slider.setScale(v, v);
      slider.setScale(.3, .3);
      slider.setSliderVisible(true);
      new SwapSprite(.3, 1, (v: number) => onUpdate(v));
    })
  })
}

export function rotateCircleAnim(callback: (a: number) => void): Promise<void> {
  return new Promise(resolve => new RotateCircleAnim(callback, 1, resolve, resolve));
}

export function addCustomDelay(delay: number): Promise<void> {
  return new Promise(resolve => new CustomDelay(delay, resolve))
}